module.exports = __webpack_public_path__ + "img/wallet.41aff4cc.png";